module.exports = __webpack_public_path__ + "img/sld_dcdb.5d9c420f.svg";